import "./new-order-notification.scss";

import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import { ReactComponent as CloseIcon } from "@client/components/reusable/SvgIcons/library/close_icon2.svg";
import { ReactComponent as NewOrderIcon } from "@client/components/reusable/SvgIcons/library/new_order_icon.svg";
import { useRootContext } from "@client/context/RootContext";

import SvgIcon from "../reusable/SvgIcons";

interface NewOrderNotificationProps {
	notificationMessage: string;
	buttonText: string;
	link: string;
}

export const NewOrderNotification = observer(
	(props: NewOrderNotificationProps) => {
		const {
			layoutStore: { setIsNewOrder },
		} = useRootContext();

		return (
			<div className="notification-container">
				<div className="notification-wrapper">
					<SvgIcon
						component={CloseIcon}
						className="notification-close-icon"
						width="20"
						height="20"
						onClick={() => setIsNewOrder(false)}
					/>
					<SvgIcon
						component={NewOrderIcon}
						className="notification-icon"
						width="40"
						height="40"
					/>
					<div className="notification-message">
						{props.notificationMessage}
					</div>
					<Link
						className="notification-active-orders-button"
						to={props.link}
						onClick={() => setIsNewOrder(false)}
					>
						{props.buttonText}
					</Link>
				</div>
			</div>
		);
	}
);
